import { render, staticRenderFns } from "./CounterBase.vue?vue&type=template&id=040b4ce9&scoped=true&"
import script from "./CounterBase.vue?vue&type=script&lang=js&"
export * from "./CounterBase.vue?vue&type=script&lang=js&"
import style0 from "./CounterBase.vue?vue&type=style&index=0&id=040b4ce9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040b4ce9",
  null
  
)

export default component.exports